import {
  Tooltip
} from "@fluentui/react-components";
import { ListChevronsDownUp, ListChevronsUpDown } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import Input from "../../components/controls/input/customInput/CustomInput";
import InputUnderline from "../../components/controls/input/InputUnderline";
import ListingHeader from "../../components/controls/listingHeader/ListingHeader";
import Modal from "../../components/controls/modal/Modal";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import ModalCheckboxWarning from "../../components/controls/modalcheckbox/ModalCheckboxWarning";
import Searchable from "../../components/controls/select/CustomSelect";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";
import { TABLE_ACTIONS } from "../../components/controls/tables/utils/tableUtils";
import DateRangeWithDuration from "../../components/dateRangeWithDuration/DateRangeWithDuration";
import OverviewHeader from "../../components/overviewHeader/OverviewHeader";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import TaskDependencies from "../../components/taskDependencies/TaskDependencies";
import TaskResourceAllocationManager from "../../components/taskResourceAllocation/TaskResourceAllocationManager";
import {
  ScopeStatus,
  calculatePageSize,
  getLabelByType,
  scopePriorityOptions,
  taskPriorityOptions,
  taskStatusOptions
} from "../../helpers/utils";
import {
  CalendarIcon
} from "../../modules/default-svg";
import { generalActions } from "../../store/actions";
import clientService from "../../store/services/clients.service";
import scopeService from "../../store/services/scope.service";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import {
  dateOnlyFormatted,
  isDateGreaterThan,
  weeksBetweenDates
} from "../../utils/systemSettings";
import KanbanBoard from "../kanbanBoard";
import AssociatedRisks from "../risk/AssociatedRisks";
import { AlertTriangle, XCircle, X } from "lucide-react";
import SafeHtml from "../../components/safeHtml/SafeHtml";
import {
  nextWorkingDayAfter,
  calendarDaysDiff,
  shiftDateStr,
} from "./utils";

const ScopeOverview = (props) => {
  const {
    scopeID,
    allTasks,
    pageLoading,
    pagination,
    getTasksRequest,
    deleteTaskRequest,
    duplicateTaskRequest,
    error,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [scopeLoading, setScopeLoading] = useState(false);
  const [isEditTask, setIsEditTask] = useState(false);
  const [isTaskLoading, setIsTaskLoading] = useState(false);
  const [isTaskActionCompleted, setIsTaskActionCompleted] = useState(false);
  const [setting] = useState(settings);
  const [project, setProject] = useState({});
  const [isCreate, setIsCreate] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [data, setData] = useState([]);
  const [overviewHeaderFields, setOverviewHeaderFields] = useState([]);
  const [headerTitle, setHeaderTitle] = useState([]);
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [status, setStatus] = useState(0);
  const [priority, setPriority] = useState(0);
  const [budget, setBudget] = useState("");
  const [phase, setPhase] = useState("");
  const [scopes, setScopes] = useState([]);
  const [taskScope, setTaskScope] = useState("");
  const [refId, setRefId] = useState("");
  const [description, setDescription] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const [isCritical, setIsCritical] = useState(false);
  const [isTaskMilestone, setIsTaskMilestone] = useState(false);
  const [isInWsr, setIsInWsr] = useState(false);
  const [kanbanView, setKanbanView] = useState(false);
  const [taskDependencies, setTaskDependencies] = useState([]);
  const [taskAllocations, setTaskAllocations] = useState([]);
  const [taskAttachments, setTaskAttachments] = useState([]);
  const [taskDependenciesDto, setTaskDependenciesDto] = useState([]);
  const [taskProgress, setTaskProgress] = useState(0);
  const [taskRisks, setTaskRisks] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [scopeName, setScopeName] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");
  const [isMilestone, setIsMilestone] = useState(false);
  const [isScopeLoading, setIsScopeLoading] = useState(false);
  const [ClientId, setClientId] = useState("");
  const [PortfolioId, setPortfolioId] = useState("");
  const [ProgramId, setProgramId] = useState("");
  const [ProjectId, setProjectId] = useState("");
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [scopeSelectedResources, setSelectedReources] = useState([]);
  const [scopeResources, setScopeResources] = useState([]);
  const [scopeProgress, setScopeProgress] = useState(0);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [scopeRisks, setScopeRisks] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [taskDateConflicts, setTaskDateConflicts] = useState([]);
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(localStorage.getItem("isOverviewHeaderCollapsed") === "true");
  const [formErrors, setFormErrors] = useState({
    name: "",
    startDate: "",
    endDate: "",
    completionDate: "",
  });
  const [tableSearch, setTableSearch] = useState(null);
  const [redirectionItem, setRedirectionItem] = useState(null);
  const [scopeDetailedResources, setScopeDetailedResources] = useState([]);
  const [isResourcesLoading, setIsResourcesLoading] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const rId = searchParams.get('r_id'); // redirection id
    if (allTasks && rId) {
      setRedirectionItem({ id: rId });
    }
  }, [location.search, allTasks]);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = {
      id: scopeID,
      parent: "Scope",
      page: pageNumber ?? pageNum,
      size: pageSize ?? perPageItems,
      search: forceClearSearch ? null : (searchTerm ?? tableSearch)
    };

    getTasksRequest(payload);
  };
  const handleHeaderSectionState = () => {
    setIsHeaderCollapsed(!isHeaderCollapsed);
    localStorage.setItem("isOverviewHeaderCollapsed", !isHeaderCollapsed);
  };

  const fetchTaskData = async (taskId) => {
    setIsTaskLoading(true);
    scopeService
      .getTaskDetails({ id: taskId ? taskId : selectedRow.id })
      .then((taskData) => {
        setName(taskData.name);
        setStartDate(taskData.startDate);
        setEndDate(taskData.endDate);
        setCompletionDate(taskData.completionDate);
        if (taskData.scopes?.[0]) {
          setTaskScope({
            label: taskData.scopes[0].name,
            value: taskData.scopes[0].id,
          });
        }
        setPriority(taskData.priority);
        setPhase(taskData.phase);
        setTaskProgress(taskData.progress);
        setTaskRisks(taskData.risks);
        setStatus(taskData.status);
        setRefId(taskData.refId);
        setDescription(taskData.description);
        setIsCritical(taskData.isCritical);
        setIsTaskMilestone(taskData.isMilestone);
        setIsDraft(taskData.isDraft);
        setIsInWsr(taskData.isInWsr);
        setTaskDependencies(taskData.dependencies);
        setTaskAllocations(taskData.allocations || []);
        setTaskAttachments(taskData.attachments || []);
        setTaskDateConflicts([]);
        setIsTaskLoading(false);
      })
      .catch(() => { });
  };

  const handleListingView = () => setKanbanView(false);
  const handleKanbanView = () => setKanbanView(true);

  const handleEdit = () => {
    setIsEdit(true);
    setStartDate("");
    setEndDate("");
    setIsButtonLoading(false);
    setTaskProgress(0);
    setTaskRisks([]);
  };

  const handleCreate = () => {
    setIsCreate(true);
    setStartDate("");
    setEndDate("");
    setIsButtonLoading(false);
    setTaskProgress(0);
    setTaskRisks([]);
  };

  const handleSave = () => {
    // Build AssignedResources payload
    const assignedResourcesPayload = (taskAllocations || []).map((a) => ({
      resourceId: a.resource?.id,
      hoursPerDay: a.hoursPerDay,
      startDate: a.startDate,
      endDate: a.endDate,
      isIncludeWeekends: a.isIncludeWeekends,
    }))

    const payload = {
      ...(name && { Name: name }),
      ...(refId && { RefId: refId }),
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
      ...(completionDate && { completionDate: completionDate }),
      ...(description && { Description: description }),
      ...(phase && { Phase: phase }),
      ...(isDraft && { isDraft: isDraft }),
      ...(isCritical && { isCritical: isCritical }),
      ...(isTaskMilestone && { isMilestone: isTaskMilestone }),
      ...(isInWsr && { isInWsr: isInWsr }),
      AssignedScopes: taskScope ? [taskScope.value] : [scopeID],
      AssignedResources: assignedResourcesPayload,
      progress: taskProgress || 0,
      Dependencies: taskDependenciesDto,
      status,
      priority,
    };

    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }

    setIsButtonLoading(true);

    if (Object.keys(selectedRow).length > 0) {
      scopeService
        .updateTaskRequest({
          id: selectedRow.id,
          payload,
        })
        .then((response) => {
          const result = response?.data ?? response;
          const value = result?.value ?? result;
          setIsButtonLoading(false)
          if (value && value.isPermissible === false) {
            setTaskDateConflicts(value.conflicts || []);
            return;
          }
          setTaskDateConflicts([]);
          dispatch(
            generalActions.showToast({
              title: "Task updated successfully",
              type: "success",
            })
          );
          setIsTaskActionCompleted(true);
          handleReset();
          fetchData();
        })
        .catch((error) => {
          setIsTaskActionCompleted(true);
          setIsButtonLoading(false)
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
        });
    } else {
      scopeService
        .createTaskRequest(payload)
        .then((response) => {
          setIsButtonLoading(false)
          const result = response?.data ?? response;
          const value = result?.value ?? result;

          if (value && value.isPermissible === false) {
            setTaskDateConflicts(value.conflicts || []);
            return;
          }
          setTaskDateConflicts([]);
          dispatch(
            generalActions.showToast({
              title: "Task created successfully",
              type: "success",
            })
          );
          setIsTaskActionCompleted(true);
          handleReset();
          fetchData();
        })
        .catch((error) => {
          setIsTaskActionCompleted(true);
          setIsButtonLoading(false)
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
        });
    }
  };

  const handleDelete = (selectedRow) => {
    setIsButtonLoading(true);
    const tId = selectedRow.id;
    deleteTaskRequest({ parent: "Scope", id: scopeID, tId: tId });
    setIsTaskActionCompleted(true);
    handleReset();
  };

  const handleReset = () => {
    setFormErrors({});
    setIsDraft(false);
    setIsCritical(false);
    setIsTaskMilestone(false);
    setIsInWsr(false);
    setIsEdit(false);
    setIsCreate(false);
    setTaskDependencies([]);
    setTaskDependenciesDto([]);
    setTaskAllocations([]);
    setTaskProgress(0);
    setTaskRisks([]);
    setTaskAttachments([]);
    setTaskDateConflicts([]);
    setIsTaskActionCompleted(false);
  };

  const handleCancel = () => {
    setIsCreate(false);
    setIsEdit(false);
    setSelectedRow({});
    handleReset();
  };

  const searchScopeHandler = (value) => {
    const payload = {
      projectId: project.id,
      value,
    };
    scopeService
      .searchScopeRequest(payload)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setScopes(transformedArray);
      })
      .catch(() => {
        setScopes([]);
      });
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  const handleInputScopeChange = (value, name) => {
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);
    if (name === "revisedEndDate") setRevisedEndDate(value);
    if (name === "scopeName") {
      setScopeName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleTaskReset = () => {
    setIsEditTask(false);
    const params = new URLSearchParams(location.search);
    params.delete("taskId");
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const taskId = params.get("taskId");
    if (taskId) {
      setIsEditTask(true);
      fetchTaskData(taskId);
    }
  }, [location, history]);

  useEffect(() => {
    if (allTasks && allTasks.length > 0) {
      if (isCreateNewRow) {
        setData(
          allTasks.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allTasks.sort((a, b) => {
              return b.isFlagged - a.isFlagged;
            })
          );
        } else {
          setData((prevData) => {
            const newData = [...prevData, ...allTasks].reduce(
              (unique, item) => {
                return unique.some(
                  (allocatedResource) => allocatedResource.id === item.id
                )
                  ? unique
                  : [...unique, item];
              },
              []
            );
            return newData.sort((a, b) => {
              return b.isFlagged - a.isFlagged;
            });
          });
        }
      }
    } else if (allTasks && allTasks.length === 0 && pageNum === 1) {
      setData([]);
    }

    setEditModal(false);
    setIsCreate(false);
    setIsEdit(false);
    setSelectedRow({});
  }, [allTasks]);

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3)
  }, []);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchTaskData();
    } else {
      setName("");
      setStartDate("");
      setEndDate("");
      setCompletionDate("");
      setStatus(0);
      setBudget("");
      setPhase("");
      setRefId("");
      setTaskProgress(0);
      setTaskRisks([]);
      setDescription("");
      setIsCritical(false);
      setIsTaskMilestone(false);
      setIsDraft(false);
      setIsInWsr(false);
      setPriority(0);
      setTaskDependencies([]);
      setTaskAttachments([]);
      setTaskAllocations([]);
      setTaskDateConflicts([]);
      setIsTaskActionCompleted(true);
    }
  }, [selectedRow, isEdit]);

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
  }, [name]);

  useEffect(() => {
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endDate: `End date must be equal to or greater than start date.`,
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        endDate: "",
      }));
    }
  }, [endDate]);

  useEffect(() => {
    if (
      startDate &&
      completionDate &&
      isDateGreaterThan(startDate, completionDate)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        completionDate: `Completion date must be equal to or greater than start date.`,
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        completionDate: "",
      }));
    }
  }, [completionDate]);

  const handleAllocationsChange = (allocations) => {
    // allocationsPayload: [{ resource, resourceId, hoursPerDay, TotalHours, StartDate, EndDate, isIncludeWeekends }]
    setTaskAllocations(allocations);

    // Auto-update task dates from allocation min/max
    const dates = allocations
      .filter((a) => (a.startDate || a.StartDate) && (a.endDate || a.EndDate))
      .map((a) => ({ start: a.startDate || a.StartDate, end: a.endDate || a.EndDate }));

    if (dates.length > 0) {
      const minStart = dates.reduce((min, d) => (d.start < min ? d.start : min), dates[0].start);
      const maxEnd = dates.reduce((max, d) => (d.end > max ? d.end : max), dates[0].end);
      setStartDate(minStart);
      setEndDate(maxEnd);
    }
  };

  const handleTaskDependenciesChange = (dependencies) => {
    setTaskDependenciesDto(dependencies);

    if (!dependencies?.length) return;

    // compute the most-restrictive required start date
    let requiredStart = null;
    for (const dep of dependencies) {
      let depRequired = null;
      if (dep.dependencyType === 0 && dep.endDate) {
        // FS: this task must start the next working day after the dep ends
        depRequired = nextWorkingDayAfter(dep.endDate);
      } else if (dep.dependencyType === 1 && dep.startDate) {
        // SS: this task must start on the same day as the dep
        depRequired = dep.startDate.split('T')[0];
      }
      if (depRequired && (!requiredStart || depRequired > requiredStart)) {
        requiredStart = depRequired;
      }
    }

    if (!requiredStart) return;

    // bail early if the current start already satisfies every dep
    if (startDate && requiredStart <= startDate) return;

    const hasProgress = Number(taskProgress) > 0;
    // deltaDays is only meaningful when startDate exists
    const deltaDays = startDate ? calendarDaysDiff(startDate, requiredStart) : 0;

    // shift task dates
    if (!hasProgress) {
      setStartDate(requiredStart);
      if (endDate && deltaDays > 0) {
        setEndDate(shiftDateStr(endDate, deltaDays));
      }
    } else {
      // Progress > 0: start date is frozen — only shift endDate
      if (endDate && deltaDays > 0) {
        setEndDate(shiftDateStr(endDate, deltaDays));
      }
    }

    // shift allocations that have dates
    // Only possible when we have a delta (startDate existed before the change)
    if (taskAllocations?.length > 0 && deltaDays > 0) {
      const updatedAllocations = taskAllocations.map((a) => {
        const aStart = a.startDate;
        const aEnd = a.endDate;
        if (!aStart && !aEnd) return a; // nothing to shift

        if (!hasProgress) {
          // Shift both dates, preserving duration
          return {
            ...a,
            startDate: aStart ? shiftDateStr(aStart, deltaDays) : null,
            endDate: aEnd ? shiftDateStr(aEnd, deltaDays) : null,
            isDirty: true,
          };
        } else {
          // Progress > 0: only shift endDate
          if (!aEnd) return a;
          return { ...a, endDate: shiftDateStr(aEnd, deltaDays), isDirty: true };
        }
      });
      setTaskAllocations(updatedAllocations);
    }
  };

  const taskFormBody = () => {
    return (
      <>
        <div className="d-flex align-items-end justify-content-between">
          <div className="col-10">
            <InputUnderline
              placeholder="Add task name"
              value={name}
              error={formErrors.name}
              handleChange={setName}
              isRequired
              loading={isTaskLoading}
            />
          </div>
          <div className="w-20 ml-2">
            <Input
              icon="%"
              placeholder="0"
              max={100}
              value={taskProgress}
              type="number"
              handleChange={setTaskProgress}
              label="Progress"
              loading={isTaskLoading}
            />
          </div>
        </div>

        <div className="flex col-10 gap-3 mt-3">
          <ModalCheckboxWarning
            label={isCritical ? "Critical" : "Mark as Critical"}
            checked={isCritical}
            setChecked={setIsCritical}
            loading={isTaskLoading}
          />
          <ModalCheckbox
            label={isTaskMilestone ? "Milestone" : "Mark as Milestone"}
            checked={isTaskMilestone}
            setChecked={setIsTaskMilestone}
            loading={isTaskLoading}
          />
          <ModalCheckbox
            label={isInWsr ? "In WSR" : "Include in WSR"}
            checked={isInWsr}
            setChecked={setIsInWsr}
            loading={isTaskLoading}
          />
        </div>

        <TaskDependencies
          projectId={project.id}
          scope={taskScope}
          taskDependencies={taskDependencies}
          onDependenciesChange={handleTaskDependenciesChange}
          loading={isTaskLoading}
        />

        {isEdit && <AssociatedRisks isLoading={isTaskLoading} risks={taskRisks} />}

        <div className="row align-items-center gx-3 my-3">
          <div className="col-6">
            <Searchable
              label="Scope"
              SelectText="Scope"
              searchText={searchScopeHandler}
              options={scopes}
              defaultVal={taskScope}
              onChange={setTaskScope}
              loading={isTaskLoading}
            />
          </div>
        </div>

        <div className="row align-items-center gx-3 my-3">
          <TaskResourceAllocationManager
            scopeId={taskScope?.value || scopeID}
            taskId={isEdit ? selectedRow?.id : null}
            allocations={taskAllocations}
            onChange={handleAllocationsChange}
            onTaskDateConflicts={setTaskDateConflicts}
            loading={isTaskLoading}
            buttonLabel="Assign Resources"
            taskStartDate={startDate}
            taskEndDate={endDate}
          />
        </div>

        <div className="row align-items-center gx-3 mb-3">
          <div className="col-12">
            {taskDateConflicts.length > 0 && (() => {
              const hasError = taskDateConflicts.some(c => c.conflictType === "ResourceCapacity");
              const borderColor = hasError ? "#f87171" : "#fb923c";
              const bgColor = hasError ? "#fef2f2" : "#fff7ed";
              const headerColor = hasError ? "#b91c1c" : "#c2410c";
              return (
                <div style={{
                  border: `1px solid ${borderColor}`,
                  borderRadius: "8px",
                  background: bgColor,
                  padding: "10px 14px",
                  marginBottom: "12px",
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                    <span style={{ fontWeight: 600, fontSize: "14px", color: headerColor }}>Date conflicts detected</span>
                    <button
                      type="button"
                      onClick={() => setTaskDateConflicts([])}
                      style={{ background: "none", border: "none", cursor: "pointer", padding: "2px", color: headerColor }}
                    >
                      <X size={14} />
                    </button>
                  </div>
                  {Object.entries(
                    taskDateConflicts.reduce((acc, c) => {
                      const key = c.conflictType || "Other";
                      if (!acc[key]) acc[key] = [];
                      acc[key].push(c);
                      return acc;
                    }, {})
                  ).map(([type, items], idx) => (
                    <div key={type} style={idx > 0 ? { marginTop: "8px", paddingTop: "8px", borderTop: "1px solid rgba(0,0,0,0.06)" } : undefined}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: 600, fontSize: "13px", color: "#374151", marginBottom: "4px" }}>
                        {type === "ResourceCapacity"
                          ? <XCircle size={16} style={{ color: "#dc2626", flexShrink: 0 }} />
                          : <AlertTriangle size={16} style={{ color: "#ea580c", flexShrink: 0 }} />}
                        <span>{type.replace(/([a-z])([A-Z])/g, "$1 $2")}</span>
                      </div>
                      <ul style={{ margin: 0, padding: "0 0 0 22px", listStyle: "none", display: "flex", flexDirection: "column", gap: "4px" }}>
                        {items.map((c, i) => (
                          <li key={i} style={{ fontSize: "13px", color: "#1a1a1a", lineHeight: 1.4 }}>
                            <SafeHtml html={c.message} className="" style={{ flex: 1 }} />
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
          <DateRangeWithDuration
            isLoading={isTaskLoading}
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            startDateError={formErrors.startDate}
            endDateError={formErrors.endDate}
            isStartDateDisabled={Number(taskProgress) > 0}
            icon={<CalendarIcon />}
          />
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={completionDate}
              minDate={endDate || startDate}
              type="date"
              handleChange={setCompletionDate}
              label="Completion Date"
              errorMessage={formErrors.completionDate}
              loading={isTaskLoading}
            />
          </div>
        </div>

        <div className="row align-items-center gx-3 mb-3">
          <div className="col-3">
            <DropDown
              label="Priority"
              options={taskPriorityOptions}
              defaultVal={getLabelByType("taskPriority", priority)}
              onChange={setPriority}
              loading={isTaskLoading}
            />
          </div>
          <div className="col-3">
            <DropDown
              label="Status"
              options={taskStatusOptions}
              defaultVal={getLabelByType("taskStatus", status)}
              onChange={setStatus}
              loading={isTaskLoading}
            />
          </div>
          <div className="col-3">
            <Input
              icon={false}
              placeholder="Enter phase"
              value={phase}
              type="text"
              handleChange={setPhase}
              label="Phase"
              loading={isTaskLoading}
            />
          </div>
          <div className="col-3">
            <Input
              icon={false}
              placeholder="Enter Change Ticket"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Change Ticket"
              loading={isTaskLoading}
            />
          </div>
        </div>

        <RichTextEditor
          wrapperClass="mb-3"
          label="Description"
          content={description}
          onChange={setDescription}
          loading={isTaskLoading}
        />

        {isEdit && selectedRow && (
          <EntityFileUpload
            entityId={selectedRow?.id}
            entityType="Task"
            attachments={taskAttachments}
            onAttachmentsChange={async () => {
              if (selectedRow?.id) {
                scopeService
                  .getTaskAttachements({ id: selectedRow?.id })
                  .then((attachements) => {
                    setTaskAttachments(attachements || []);
                  });
              }
            }}
            disabled={isTaskLoading}
          />
        )}
      </>
    );
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClientOptions([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setProgramOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Scope";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Scope";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const fetchScopeResources = () => {
    setIsResourcesLoading(true);
    scopeService.getTeam(scopeID)
      .then((response) => {
        setScopeDetailedResources(response);
      }
      )
      .catch((error) => { })
      .finally(() => {
        setIsResourcesLoading(false);
      });
  }

  useEffect(() => {
    if (scopeID) {
      fetchScopeResources();
    }
  }, [scopeID]);

  const fetchScopeData = async () => {
    setIsScopeLoading(true);
    scopeService
      .getScopeDetailsRequest({ id: scopeID })
      .then((scopeData) => {
        setScopeName(scopeData.name);
        setStartDate(scopeData.startDate);
        setEndDate(scopeData.endDate);
        setRevisedEndDate(scopeData.revisedEndDate);
        setPriority(scopeData.priority);
        setBudget(scopeData.budget);
        setPhase(scopeData.phase);
        setStatus(scopeData.status);
        setRefId(scopeData.refId);
        setDescription(scopeData.description);
        setScopeProgress(scopeData.progress);
        scopeData.client
          ? setClientId({
            label: scopeData.client.name,
            value: scopeData.client.id,
          })
          : setClientId("");
        scopeData.portfolio
          ? setPortfolioId({
            label: scopeData.portfolio.name,
            value: scopeData.portfolio.id,
          })
          : setPortfolioId("");
        scopeData.program
          ? setProgramId({
            label: scopeData.program.name,
            value: scopeData.program.id,
          })
          : setProgramId("");
        scopeData.project
          ? setProjectId({
            label: scopeData.project.name,
            value: scopeData.project.id,
          })
          : setProjectId("");
        setScopeRisks(scopeData.risks);
        setAttachments(scopeData.attachments || []);
        const scopeTitle = {
          name: scopeData.name,
          client: scopeData.client,
        };
        setHeaderTitle(scopeTitle);

        const res = [
          {
            ...scopeData.creator,
            label: "Created By",
            isResource: true,
          },
          {
            ...scopeData.owner,
            label: "Project Manager",
            isResource: true,
          },
          {
            label: "Start Date",
            name: scopeData.startDate
              ? dateOnlyFormatted(setting, scopeData.startDate)
              : <>&nbsp;</>,
          },
          {
            label: "End Date",
            name:
              scopeData.endDate || scopeData.revisedEndDate
                ? dateOnlyFormatted(
                  setting,
                  scopeData.endDate || scopeData.revisedEndDate
                )
                : <>&nbsp;</>,
          },
          {
            label: "Scope Duration",
            name:
              scopeData.startDate &&
                (scopeData.endDate || scopeData.revisedEndDate)
                ? weeksBetweenDates(
                  scopeData.startDate,
                  scopeData.endDate || scopeData.revisedEndDate
                )
                : <>&nbsp;</>,
          },
        ];
        setProject(scopeData.project);
        setOverviewHeaderFields(res);
      })
      .catch((error) => console.error("Error fetching scope data:", error))
      .finally(() => {
        setIsScopeLoading(false);
      });
  };

  const handleResetScope = () => {
    setIsScopeLoading(false);
    setDeleteModal(false);
    setEditModal(false);
    setScopeName("");
    setRevisedEndDate("");
    setIsMilestone(false);
    setClientId("");
    setPortfolioId("");
    setProgramId("");
    setProjectId("");
    setClientOptions([]);
    setPortfolioOptions([]);
    setProgramOptions([]);
    setProjectOptions([]);
    setScopeResources([]);
    setSelectedReources([]);
    setStartDate("");
    setEndDate("");
    setPriority(0);
    setBudget("");
    setPhase();
    setStatus(0);
    setRefId("");
    setDescription();
    setScopeRisks([]);
    setAttachments([]);
  };

  const handleUpdateScope = () => {
    if (!budget) setBudget(null);
    const errors = {};
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    if (
      startDate &&
      revisedEndDate &&
      isDateGreaterThan(startDate, revisedEndDate)
    ) {
      errors[
        "revisedEndDate"
      ] = `Revised end date must be equal to or greater than start date.`;
    }
    if (!scopeName) errors["scopeName"] = `The Name field is required.`;
    if (!ProjectId) errors["projectId"] = `The Project field is required.`;
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      Name: scopeName,
      ProjectId: ProjectId?.value,
      StartDate: startDate ? startDate : null,
      EndDate: endDate ? endDate : null,
      RevisedEndDate: revisedEndDate ? revisedEndDate : null,
      Priority: priority,
      Budget: budget ? budget : 0,
      Phase: phase,
      Status: status,
      RefId: refId,
      Description: description,
      AssignedUsers: [...scopeSelectedResources.map((obj) => obj.value), ...scopeResources],
      IsMilestone: isMilestone,
    };
    setIsButtonLoading(true);
    scopeService
      .updateScopeRequest({
        id: scopeID,
        type: "overview",
        payload,
      })
      .then(() => {
        dispatch(
          generalActions.showToast({
            type: "success",
            message: "Scope updated successfully.",
          })
        );
      })
      .catch((error) => {
        console.error("Error updating scope:", error);
        dispatch(
          generalActions.showToast({
            type: "error",
            message: "Error updating scope.",
          })
        );
      })
      .finally(() => {
        setIsButtonLoading(false);
        setEditModal(false);
        fetchScopeData();
      });
  };

  const scopeFormBody = () => {
    return (
      <div>
        <div className="d-flex align-items-end justify-content-between">
          <div className="col-10">
            <InputUnderline
              placeholder="Add scope name"
              value={scopeName}
              error={formErrors.scopeName}
              handleChange={(value) =>
                handleInputScopeChange(value, "scopeName")
              }
              isRequired
              loading={isScopeLoading}
            />
          </div>
          <div className="col-1 ml-2">
            <label class="Input_label">Progress</label>
            <p
              style={{ border: "1px solid #342C82" }}
              className="text-xs text-[#1F1F1F] font-semibold bg-[#EDECF8] text-center py-[4px] rounded-md"
            >
              {`${scopeProgress} %`}
            </p>
          </div>
        </div>
        <div className="mt-3 w-25">
          <ModalCheckbox
            label={isMilestone ? "Milestone" : "Mark as Milestone"}
            checked={isMilestone}
            setChecked={setIsMilestone}
          />
        </div>

        <TaskDependencies
          projectId={project.id}
          scope={taskScope}
          taskDependencies={taskDependencies}
          onDependenciesChange={setTaskDependenciesDto} />

        {<AssociatedRisks isLoading={isScopeLoading} risks={scopeRisks} />}

        <div className="row gx-3">
          <div className="col mt-4 w-100">
            <Searchable
              label="Client"
              SelectText="client"
              searchText={searchClientHandler}
              options={clientOptions}
              defaultVal={ClientId}
              onChange={(e) => {
                setClientId(e);
                setPortfolioId("");
                setProgramId("");
                setProjectId("");
              }}
              loading={isScopeLoading}
            />
          </div>
          <div className="col mt-4 w-100">
            <Searchable
              label="Portfolio"
              SelectText="portfolio"
              searchText={searchPortfolioHandler}
              options={portfolioOptions}
              defaultVal={PortfolioId}
              onChange={(e) => {
                setPortfolioId(e);
                setProgramId("");
                setProjectId("");
              }}
              loading={isScopeLoading}
            />
          </div>
        </div>
        <div className="row gx-3 mb-3">
          <div className="col mt-4 w-100">
            <Searchable
              label="Program"
              SelectText="program"
              searchText={searchProgramHandler}
              options={programOptions}
              defaultVal={ProgramId}
              onChange={(e) => {
                setProgramId(e);
                setProjectId("");
              }}
              loading={isScopeLoading}
            />
          </div>
          <div className="col mt-4 w-100">
            <Searchable
              label="Project"
              SelectText="project"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={ProjectId}
              onChange={(e) => setProjectId(e)}
              errorMessage={formErrors.projectId}
              isRequired
              loading={isScopeLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <DateRangeWithDuration
            startDate={startDate}
            endDate={endDate}
            revisedEndDate={revisedEndDate}
            onStartDateChange={(value) => handleInputScopeChange(value, "startDate")}
            onEndDateChange={(value) => handleInputScopeChange(value, "endDate")}
            onRevisedEndDateChange={(value) => handleInputScopeChange(value, "revisedEndDate")}
            startDateError={formErrors.startDate}
            endDateError={formErrors.endDate}
            showRevisedEndDate={true}
            icon={<CalendarIcon />}
            isLoading={isScopeLoading}
          />
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <DropDown
              label="Status"
              options={ScopeStatus}
              defaultVal={getLabelByType("scope", status)}
              onChange={setStatus}
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Priority"
              options={scopePriorityOptions}
              defaultVal={getLabelByType("scopePriority", priority)}
              onChange={setPriority}
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              value={budget}
              type="number"
              currency={true}
              placeholder="0"
              handleChange={setBudget}
              label="Budget"
              loading={isScopeLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter phase"
              value={phase}
              type="text"
              handleChange={setPhase}
              label="Phase"
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter Reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
              loading={isScopeLoading}
            />
          </div>
        </div>

        <div className="mb-3">
          <RichTextEditor
            label="Description"
            content={description}
            onChange={setDescription}
            loading={isScopeLoading}
          />
        </div>
        <EntityFileUpload
          entityId={scopeID}
          entityType="Scope"
          attachments={attachments}
          onAttachmentsChange={() => {
            scopeService.getScopeDetailsRequest({ id: scopeID })
              .then((scopeData) => {
                setAttachments(scopeData.attachments);
              })
              .catch((error) => {
                console.error("Error fetching scope data:", error);
              });
          }}
          disabled={isScopeLoading || !scopeID}
        />
      </div>
    );
  };

  useEffect(() => {
    setScopeLoading(true);
    scopeService
      .getScopeDetailsRequest({ id: scopeID })
      .then((scopeDetails) => {
        const scopeTitle = {
          name: scopeDetails.name,
          client: scopeDetails.client,
        };
        setHeaderTitle(scopeTitle);
        const res = [
          {
            ...scopeDetails.creator,
            label: "Created By",
            isResource: true,
          },
          {
            ...scopeDetails.owner,
            label: "Project Manager",
            isResource: true,
          },
          {
            label: "Start Date",
            name: scopeDetails.startDate
              ? dateOnlyFormatted(setting, scopeDetails.startDate)
              : <>&nbsp;</>,
          },
          {
            label: "End Date",
            name:
              scopeDetails.endDate || scopeDetails.revisedEndDate
                ? dateOnlyFormatted(
                  setting,
                  scopeDetails.endDate || scopeDetails.revisedEndDate
                )
                : <>&nbsp;</>,
          },
          {
            label: "Scope Duration",
            name:
              scopeDetails.startDate &&
                (scopeDetails.endDate || scopeDetails.revisedEndDate)
                ? weeksBetweenDates(
                  scopeDetails.startDate,
                  scopeDetails.endDate || scopeDetails.revisedEndDate
                )
                : <>&nbsp;</>,
          },
        ];
        setProject(scopeDetails.project);
        setOverviewHeaderFields(res);
        setTaskScope({
          label: scopeDetails.name,
          value: scopeDetails.id,
        });
      })
      .catch((error) => {
        console.log("Error fetching scope details:", error);
      })
      .finally(() => {
        setScopeLoading(false);
      });
  }, []);

  const handleDeleteScope = () => {
    setIsButtonLoading(true);
    scopeService
      .deleteScopeRequest(scopeID)
      .then(() => {
        history.goBack();
        dispatch(
          generalActions.showToast({
            type: "success",
            message: "Scope deleted successfully.",
          })
        );
      })
      .catch((error) => {
        dispatch(
          generalActions.showToast({
            type: "error",
            message: "Error deleting scope.",
          })
        );
        console.error("Error deleting scope:", error);
      })
      .finally(() => {
        setIsButtonLoading(false);
        setDeleteModal(false);
      });
  };

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  const handleTaskActionCallback = () => {
    fetchData(1, perPageItems);
  };

  const handleDuplicate = (props) => {
    if (props.payload.id) {
      duplicateTaskRequest(
        {
          id: props.payload.id,
          callback: handleTaskActionCallback
        }
      );
    }
  };

  const handleTableAction = (props) => {

    switch (props.actionType) {
      case TABLE_ACTIONS.DUPLICATE:
        handleDuplicate(props);
        break;

    }
  }
  return (
    <div className="relative">
      <ColumnConfigProvider tableName="Tasks">
        {
          !isHeaderCollapsed &&
          (
            <OverviewHeader
              entityType="scope"
              isShowAction
              headerTitle={headerTitle}
              headerFields={overviewHeaderFields}
              type="scope"
              loading={scopeLoading}
              showDeleteModal={() => setDeleteModal(true)}
              showEditModal={() => {
                fetchScopeData();
                setEditModal(true);
              }}
              handleScopeTeam={!isResourcesLoading ?
                {
                  id: scopeID,
                  parentId: project?.id,
                  resources: scopeDetailedResources
                } :
                null
              }
              onScopeTeamUpdated={fetchScopeResources}
            />
          )
        }

        <div
          className="TasksScreenWrapper mt-4"
          style={{
            height: `calc(100vh - ${isHeaderCollapsed ? '205' : '400'}px)`,
          }}>
          {kanbanView && (
            <ListingHeader
              type="Tasks"
              btnLable="Add Task"
              scopeID={scopeID}
              handleListingView={handleListingView}
              handleKanbanView={handleKanbanView}
              kanbanView={kanbanView}
              searchedData={handleSearch}
              setIsCreate={handleCreate}
              rightPane={true}
              triggerSearch={handleSearchTrigger}
              isSearchDisable={true}
            />
          )}
          {!kanbanView ? (
            <Table
              type="Tasks"
              rows={data || []}
              searchHandler={handleSearch}
              body={taskFormBody()}
              saveBtnLabel="Save"
              cancelBtnLabel="Cancel"
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              setIsCreate={setIsCreate}
              handleSave={() => handleSave()}
              handleDelete={(selectedRow) => handleDelete(selectedRow)}
              handleCancel={() => handleCancel()}
              setIsEdit={setIsEdit}
              loading={pageLoading}
              modalLoading={!isTaskActionCompleted}
              isCreate={isCreate}
              pagination={pagination}
              setSelectedRow={setSelectedRow}
              scopeId={scopeID}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              handleListingView={handleListingView}
              handleKanbanView={handleKanbanView}
              kanbanView={kanbanView}
              setData={setData}
              parentType="Scope"
              triggerSearch={handleSearchTrigger}
              forceShowEditModal={redirectionItem}
              handleAction={handleTableAction}
            />
          ) : (
            <KanbanBoard
              scopeID={scopeID}
              data={data}
              type="Tasks"
              isCreate={isCreate}
              setIsCreate={setIsCreate}
              loading={pageLoading}
              modalLoading={!isTaskActionCompleted}
              body={taskFormBody()}
              setSelectedRow={setSelectedRow}
              setEdit={() => handleEdit()}
              isButtonLoading={isButtonLoading}
              saveHandler={handleSave}
              heightDelta={isHeaderCollapsed ? '195px' : '370px'}
              handleAction={handleTableAction}
            />
          )}

          {deleteModal && (
            <Modal
              title={`Delete scope`}
              body={
                <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the scope?`}</p>
              }
              handleCancel={() => setDeleteModal(false)}
              handleSave={() => handleDeleteScope()}
              saveBtnLabel="Delete"
              cancelBtnLabel="Cancel"
              isLoading={isButtonLoading}
            />
          )}

          {editModal && (
            <Modal
              title={`Edit ${headerTitle.name}`}
              handleCancel={() => setEditModal(false)}
              handleSave={() => handleUpdateScope()}
              saveBtnLabel="Save"
              cancelBtnLabel="Cancel"
              isLoading={isButtonLoading}
              size="large"
              body={scopeFormBody()}
            />
          )}

          {isEditTask && (
            <Modal
              title="Edit Task"
              handleCancel={handleTaskReset}
              handleSave={handleSave}
              saveBtnLabel="Save"
              cancelBtnLabel="Cancel"
              isLoading={isButtonLoading}
              body={taskFormBody()}
              size="large"
            />
          )}
        </div>
      </ColumnConfigProvider>
      {!scopeLoading &&
        (
          <div
            className="absolute right-2 cursor-pointer opacity-50 hover:opacity-100 hover:text-[#342C82] px-3 py-1 transition-all duration-150 ease-in-out"
            style={{ top: isHeaderCollapsed ? '-2rem' : '0.25rem' }}
            onClick={handleHeaderSectionState}>
            <Tooltip content={isHeaderCollapsed ? "Expand" : "Collapse"} relationship="label" positioning="before">
              {isHeaderCollapsed ? <ListChevronsUpDown size={20} /> : <ListChevronsDownUp size={20} />}
            </Tooltip>
          </div>
        )}
    </div>
  );
};
export default ScopeOverview;
